import { render, staticRenderFns } from "./WallServicesToComplete.vue?vue&type=template&id=372030f8&"
import script from "./WallServicesToComplete.vue?vue&type=script&lang=js&"
export * from "./WallServicesToComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports